"use strict";

exports.interactiveTypesHash = {
  testCorrect: 'testCorrect',
  testSummary: 'testSummary',
  exposition: 'exposition',
  upturnCards: 'upturnCards',
  divination: 'divination',
  testTree: 'testTree',
  doubleImages: 'doubleImages'
};
exports.interactiveTypeTitlesHash = {
  testCorrect: "\u0422\u0435\u0441\u0442 \u043D\u0430\xA0\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043E\u0442\u0432\u0435\u0442\u043E\u0432",
  testSummary: "\u0422\u0435\u0441\u0442 \u043D\u0430\xA0\u0441\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442",
  exposition: 'Выставка',
  upturnCards: 'Поворачивающиеся картинки',
  divination: 'Гадание',
  testTree: "\u0422\u0435\u0441\u0442 \u0441\xA0\u0434\u0440\u0435\u0432\u043E\u0432\u0438\u0434\u043D\u043E\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u043E\u0439",
  doubleImages: 'Двойные изображения'
};
exports.upturnCardsTextAligment = {
  left: 'Слева',
  right: 'Справа'
};
exports.interactiveModesHash = {
  list: 'Полный список',
  slider: 'Слайдер'
};